module.exports = __webpack_public_path__ + "static/media/location4.07a08e9b.png";